import { gql } from 'react-apollo';

export default gql`
  query currentInvestorUser {
    currentInvestorUser {
      _id
      canViewOffers
      tenantId
      firstName
      lastName
      notifyInvestmentPreference
      email
      kycStatus
      accuantUsage
      appId
      accreditationStatus
      accreditationType
      affiliationType
      professionalDesignation
      qualifications
      centeralRegistrationNumber
      institutionalOther
      individualOther
      selectedOptionTypes
      hasUploadedKycDocx
      #accreditedOptions
      minimumInvestmentSize
      averageInvestmentSize
      preferredListingTypes
      preferredAreas
      preferredSectors
      preferredTransactionTypes
      intendInvestingFunds
      benefitInvestor
      benefitInvestorQuestions
      benefitInvestorQuestionsOther
      qualifiedPurchaserQuestion
      qualifiedPurchaser
      qualifiedPurchaseOther
      country
      address
      companyName
      income
      networth
      investorFirmexId
      investorHasCreatedFirmex
      officePhoneNumber
      mobilePhoneNumber
      suitability {
        _id
        liquidityNeeds
        riskTolerance
        yearsOfExperience
        investmentFrequency
        investmentAllocation
        investmentDecisionConsultProfessional
        investmentDecisionConsultSelf
        investmentDecisionConsultFamilyFriends
        investmentSelectionsConfirmed
      }
      createdAt
      adminCommentModerator
    }
  }
`;



// WEBPACK FOOTER //
// ./src/apollo/queries/currentInvestorUser.js